import { render, staticRenderFns } from "./RegistAccountList.vue?vue&type=template&id=16e98a36&scoped=true"
import script from "./RegistAccountList.vue?vue&type=script&lang=js"
export * from "./RegistAccountList.vue?vue&type=script&lang=js"
import style0 from "./RegistAccountList.vue?vue&type=style&index=0&id=16e98a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e98a36",
  null
  
)

export default component.exports